import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { DataService } from '../../services/data/data.service';

@Component({
	selector: 'pcm-user-landing',
	templateUrl: './user-landing.component.html',
	styleUrls: ['./user-landing.component.scss']
})
export class UserLandingComponent implements OnInit {

	constructor(
		public userService: UserService,
		public dataService: DataService
	) { }

	ngOnInit() {
		this.userService.directUser();
	}

}
